import * as React from "react";
import { forwardRef } from "react";
const SvgBack = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13 8H3M3 8L7 4M3 8L7 12", stroke: "#1A2023", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgBack);
export { ForwardRef as ReactComponent };
